var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolSeaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 32,
    viewBox: "0 0 150 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z",
    fill: "#1E1A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 21.4379H46.274C46.274 22.6401 47.3253 23.7665 49.1609 23.7665C50.8861 23.7665 52.011 22.9781 52.011 21.8516C52.011 20.8747 51.2603 20.4242 49.9483 20.1241L47.6238 19.5251C43.6867 18.4724 42.6743 16.367 42.6743 14.1563C42.6743 11.4192 45.374 9.0127 49.1987 9.0127C52.3106 9.0127 55.8356 10.5528 55.7978 14.4942H51.6356C51.6356 13.2552 50.5486 12.5046 49.3112 12.5046C47.9613 12.5046 47.0235 13.2551 47.0235 14.3447C47.0235 15.2458 47.8867 15.7711 48.8991 15.9964L51.7113 16.747C55.6475 17.7608 56.3603 20.2389 56.3603 21.8538C56.3603 25.4204 52.7984 27.2974 49.2366 27.2974C45.7494 27.2953 42.2621 25.193 42.1875 21.4379Z",
    fill: "#26184F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6953 18.0968C59.6953 12.5405 64.0057 9.01074 68.9942 9.01074C73.9827 9.01074 78.3309 12.5405 78.3309 18.0968C78.3309 23.653 73.9816 27.2954 68.9942 27.2954C64.0067 27.2954 59.6953 23.6541 59.6953 18.0968ZM73.9438 18.0968C73.9438 15.0933 71.6939 13.0658 68.9942 13.0658C66.2944 13.0658 64.0824 15.0933 64.0824 18.0968C64.0824 21.176 66.2902 23.2403 68.9942 23.2403C71.6982 23.2403 73.9438 21.176 73.9438 18.0968Z",
    fill: "#26184F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7891 0H87.1383V26.9191H82.7891V0Z",
    fill: "#26184F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4922 21.4379H95.5786C95.5786 22.6401 96.63 23.7665 98.4666 23.7665C100.191 23.7665 101.316 22.9781 101.316 21.8516C101.316 20.8747 100.566 20.4242 99.254 20.1241L96.9285 19.5251C92.9924 18.4724 91.98 16.367 91.98 14.1563C91.98 11.4192 94.6787 9.0127 98.4981 9.0127C101.611 9.0127 105.135 10.5528 105.097 14.4942H100.935C100.935 13.2552 99.848 12.5046 98.6106 12.5046C97.2607 12.5046 96.324 13.2551 96.324 14.3447C96.324 15.2458 97.1861 15.7711 98.1985 15.9964L101.011 16.747C104.948 17.7608 105.66 20.2389 105.66 21.8538C105.66 25.4204 102.098 27.2974 98.536 27.2974C95.054 27.2953 91.5668 25.193 91.4922 21.4379Z",
    fill: "#26184F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.039 19.6735H113.504C113.99 22.1137 115.866 23.358 118.452 23.358C120.364 23.358 122.164 22.6074 123.214 21.181L126.101 23.3917C124.489 25.9445 121.415 27.2962 118.227 27.2962C112.978 27.2962 109.004 23.617 109.004 18.1376C109.004 12.5434 113.203 9.01367 118.19 9.01367C123.214 9.01367 127.152 12.5055 127.152 17.987C127.146 18.5509 127.109 19.114 127.039 19.6735V19.6735ZM122.801 16.6322C122.54 14.2299 120.699 12.8424 118.265 12.8424C115.903 12.8424 114.028 13.9688 113.504 16.6322H122.801Z",
    fill: "#26184F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.231 9.38671V26.9197H144.882V24.5543C143.682 26.4323 141.207 27.2914 139.07 27.2914C134.458 27.2914 130.449 23.7247 130.449 18.1327C130.449 12.5007 134.424 9.00879 139.035 9.00879C141.243 9.00879 143.685 9.87307 144.885 11.7122V9.38671H149.231ZM144.807 18.0969C144.807 15.0188 142.257 13.066 139.745 13.066C137.045 13.066 134.833 15.1714 134.833 18.0969C134.833 21.0224 137.041 23.2036 139.745 23.2036C142.405 23.2036 144.805 21.1761 144.805 18.0969H144.807Z",
    fill: "#26184F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9083 24.8101C25.137 23.385 25.8092 21.5629 25.8007 19.6802C25.8007 15.4609 22.5258 12.0417 18.4857 12.0417C17.0345 12.0418 15.6186 12.4887 14.4297 13.3218C14.4297 13.3218 16.3641 10.3363 22.4323 11.29C28.5005 12.2438 29.5949 17.02 29.352 20.7298C28.4941 22.9801 27.0935 24.9829 25.275 26.5597L23.9083 24.8101Z",
    fill: "url(#paint0_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2561 26.5632L25.2509 26.5748C24.9775 26.8117 24.6958 27.0422 24.4003 27.2622C22.3828 28.7609 20.0145 29.7154 17.5227 30.034C16.4466 30.1715 15.3631 30.1885 14.2916 30.0875C12.882 29.9546 11.3232 29.0358 10 28.5C7.67114 27.557 6.07023 26.4635 4.5 24.5C2.92977 22.5365 1.90999 20.4817 1.5 18L6.68275 18.7789C6.96197 19.3723 7.33175 20.8456 7.72232 21.3723C10.2318 24.7599 14.3582 25.899 18.1303 24.7504C18.7033 24.5748 19.2317 24.2776 19.6796 23.8789C20.1275 23.4803 20.4843 22.9896 20.7256 22.4404C20.967 21.8912 21.0873 21.2963 21.0782 20.6964C21.0692 20.0964 20.9311 19.5054 20.6733 18.9637C20.4156 18.4221 20.0442 17.9424 19.5846 17.5574C19.1249 17.1725 18.5878 16.8913 18.0098 16.733C17.4317 16.5747 16.8264 16.5431 16.2351 16.6403C15.6438 16.7375 15.0804 16.9612 14.5832 17.2961C14.5832 17.2961 17.4333 14.9612 21.2464 16.2792C21.2464 16.2792 24.9029 17.4488 26.1098 21.3459C27.3167 25.2431 25.2561 26.5632 25.2561 26.5632Z",
    fill: "url(#paint1_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3552 20.6825C30.2303 18.3818 30.5126 15.8975 30.176 13.4587C29.8394 11.02 28.8947 8.70546 27.4292 6.72872C27.3829 6.66661 27.3335 6.60871 27.2873 6.54766L24.7389 5.24123L15.8616 3.65479L15.3359 5.57495C16.9335 5.5221 18.5201 5.8581 19.9595 6.55411C21.3989 7.25012 22.6482 8.28537 23.6003 9.57107C24.1178 10.2679 24.5387 11.0318 24.8514 11.8418L25.4359 12.1302L28.717 15.3884L29.5024 18.8771L29.3752 20.4288L29.3552 20.6825Z",
    fill: "url(#paint2_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3516 20.7294C29.8178 19.2496 29.9327 17.6813 29.6873 16.1492C29.4419 14.6172 28.8429 13.1635 27.938 11.904C27.033 10.6444 25.8471 9.61356 24.4745 8.89349C23.1019 8.17341 21.5804 7.78393 20.0311 7.75601C18.4817 7.72809 16.9473 8.0625 15.5496 8.73265C14.152 9.4028 12.9298 10.3902 11.9802 11.6164C11.0306 12.8425 10.3798 14.2736 10.0795 15.7959C9.77917 17.3181 9.83767 18.8895 10.2503 20.3851C10.4793 17.9795 11.6065 15.749 13.4067 14.1395C15.2068 12.5301 17.5472 11.6601 19.9601 11.7036C22.373 11.7471 24.6807 12.7008 26.4218 14.3741C28.1629 16.0474 29.2092 18.3171 29.3516 20.7294V20.7294Z",
    fill: "url(#paint3_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2511 26.5776C25.936 25.8886 26.4722 25.066 26.8264 24.1608C27.1805 23.2556 27.3451 22.2872 27.31 21.3156C27.2748 20.3441 27.0405 19.3902 26.6218 18.5131C26.203 17.6359 25.6087 16.8544 24.8758 16.2168C24.1428 15.5793 23.2868 15.0995 22.3608 14.807C21.4349 14.5146 20.4588 14.4159 19.4932 14.517C18.5276 14.618 17.593 14.9168 16.7475 15.3946C15.902 15.8725 15.1636 16.5192 14.5781 17.2947C15.9161 16.4159 17.5041 15.9986 19.1006 16.1063C20.6971 16.2141 22.2148 16.841 23.4229 17.8917C24.631 18.9424 25.4633 20.3595 25.7933 21.9273C26.1233 23.4952 25.9329 25.1281 25.2511 26.5776V26.5776Z",
    fill: "url(#paint4_radial)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8495 7.781C14.3925 5.89301 17.5385 5.00388 20.6921 5.28188C23.8457 5.55987 26.7882 6.98569 28.9627 9.28955C27.8778 6.94499 26.1943 4.92866 24.082 3.44424C21.9698 1.95981 19.5037 1.05987 16.9329 0.835329C14.3621 0.610787 11.7777 1.0696 9.44067 2.16541C7.10366 3.26122 5.09685 4.95522 3.62297 7.07628C2.1491 9.19735 1.26035 11.6703 1.04652 14.2455C0.832694 16.8206 1.30135 19.4066 2.40516 21.7423C3.50896 24.0779 5.20881 26.0805 7.33299 27.5478C9.45718 29.015 11.9304 29.8949 14.503 30.0986C12.406 29.2074 10.5814 27.7773 9.21372 25.9531C7.84608 24.1289 6.98398 21.9752 6.71467 19.7101C6.44536 17.4451 6.77839 15.1489 7.68007 13.0542C8.58175 10.9594 10.0201 9.1403 11.8495 7.781V7.781Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4876 15.6704) scale(10.5247 10.5388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#1C1564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1C1666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#262E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2C3CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E42C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5129 19.4668) scale(12.0586 10.6257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1C1564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1C1666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#262E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2C3CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E42C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 22.8249,
    y1: 3.65479,
    x2: 30.9065,
    y2: 16.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E42C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.15401,
    y1: 12.4645,
    x2: 31.6074,
    y2: 17.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3ECFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3DC5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#399CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#367ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#346CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3365D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3465D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6469CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8A6CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#A66EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B670C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC70BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5216 16.4503) rotate(31.7014) scale(14.9871 15.7766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58FAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498401,
    stopColor: "#3468D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B370C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 5.61412,
    y1: 21.319,
    x2: 25.87,
    y2: 3.66326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3ECFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3365D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3765D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4566CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5A68CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#796BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A06EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC70BF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolSeaLogo);
export default __webpack_public_path__ + "static/media/SolSea_Logo.5e967ad6a8698fd892d93ef77584436a.svg";
export { ForwardRef as ReactComponent };